import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function QuickWin() {
  const wins = ['Weekly system structure', 'Strategic posting logic', 'Caption writing method', 'Positioning clarity'];
  return <Section background="charcoal" className="border-t border-luxury-gold/10" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <div className="text-center mb-12" data-id="element-144">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-145">
            What you can apply{' '}
            <span className="text-luxury-gold italic" data-id="element-146">today</span>
          </h2>
          <p className="text-luxury-gray font-light" data-id="element-147">
            Immediate implementation, no fluff.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-148">
          {wins.map((win, i) => <div key={i} className="flex items-center p-6 bg-luxury-black/40 border border-white/5 hover:border-luxury-gold/30 transition-colors duration-300" data-id="element-149">
              <div className="flex-shrink-0 mr-4" data-id="element-150">
                <div className="w-8 h-8 rounded-full bg-luxury-gold/10 flex items-center justify-center" data-id="element-151">
                  <Check className="w-4 h-4 text-luxury-gold" data-id="element-152" />
                </div>
              </div>
              <span className="text-white text-lg font-light" data-id="element-153">{win}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}